<script setup>
import facebook from '@i/facebook.svg';
import linkedIn from '@i/linkedIn.svg';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';
import SocialIcon from './SocialIcon.vue';
const companyDetails = computed(() => usePage().props.company_details);
</script>

<template>
    <div class="flex gap-3">
        <SocialIcon :icon="facebook" :href="companyDetails.facebook_url" :classes="'w-3 h-auto'" />
        <!-- <SocialIcon :icon="instagram" :href="companyDetails.instagram_url" :classes="'w-4 h-auto'" /> -->
        <SocialIcon :icon="linkedIn" :href="companyDetails.linkedin_url" :classes="'w-4 h-auto'" />
    </div>
</template>
